export default __webpack_public_path__ + "static/media/belt_of_the_farseeker.0a7e09e7.jpg";